<template>
  <div>
    <toastification-progress-content ref="progressToast" />
    <b-row v-if="showFilters" class="pt-2 pb-1">
      <b-col cols="6" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
      <b-col cols="6" class="pr-3 text-right">
        <div class="d-flex justify-content-end">
          <div>
            <b-button-group>
              <b-button
                @click="$root.$emit('bv::show::modal', 'metadata_search_modal')"
                class="buttonFilter cursor-pointer"
              >
                <b-icon-filter-circle-fill scale="1" />
                <span class="align-middle ml-50">Filters</span>
              </b-button>
              <toggle-clear-filter
                @clear-search-filters="clearSearchFilters"
                :filters-count="filtersCount"
              />
            </b-button-group>
          </div>
        </div>
      </b-col>
    </b-row>

    <toastification-loading-content ref="loadingToast" />

    <!-- Table Container Card -->
    <b-card-group
      v-show="showFilters || !isFilterPanelOpen"
      deck
      :class="{ 'mx-2 mt-1': showFilters, 'm-0': !showFilters }"
    >
      <Transition name="slide-left-right">
        <b-card no-body class="m-0" v-if="!hiddenTable">
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              v-if="showFilters"
            >
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label class="text-capitalize mr-1">{{ $t("table.entries") }}</label>
              <btn-refresh-table
                :fetch-list="refetchData"
                v-if="showFilters"
              />
            </b-col>
            <!-- Search -->
            <b-col cols="12" :md="showFilters ? 6 : 12">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search') + '...'"
                />

                <b-button-group v-if="!showFilters">
                  <b-button
                    @click="isFilterPanelOpen = true"
                    class="buttonFilter cursor-pointer d-flex align-items-center"
                  >
                    <b-icon-filter-circle-fill scale="1.1" />
                    <span class="align-middle ml-1 text-capitalize">{{ $t("filters") }}</span>
                  </b-button>
                  <toggle-clear-filter
                    @clear-search-filters="clearSearchFilters"
                    :filters-count="filtersCount"
                  />
                </b-button-group>

                <b-dropdown
                  split
                  variant="success"
                  :class="showFilters ? 'mr-1' : 'ml-1'"
                  :disabled="buttonExport"
                  right
                  v-b-tooltip.hover
                  :title="$t('messages.export.title')"
                  @click="exportExcel()"
                >
                  <template #button-content>
                    <feather-icon icon="DownloadCloudIcon" size="15" />
                  </template>
                  <b-dropdown-item @click="exportExcel()">
                    {{ $t("detection_event.export_excel") }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="showFireSmokeModal = true">
                    {{ $t("detection_event.fire_smoke.option") }}
                  </b-dropdown-item>
                </b-dropdown>

                <btn-refresh-table
                  :fetch-list="refetchData"
                  class="ml-1"
                  v-if="!showFilters"
                />
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          ref="refListTable"
          class="position-relative"
          :items="fetchList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          :empty-text="$t('no_record_found')"
          :sort-desc.sync="isSortDirDesc"
          @row-selected="onRowSelected"
          select-mode="single"
          selectable
        >
          <template #head()="data">
            <span>
              {{ !["ID"].includes(data.label) ? $tc(data.label, 1) : data.label }}</span
            >
          </template>

          <template #cell(media)="data">
            <div class="hoverable">
              <b-img
                v-if="data.item.media"
                :src="data.item.media ? appendParamIfNotS3(data.item.media.url, `accessTokenimg=${tokenImg}`) : ''"
                alt="path Image"
                style="max-height: 150px; width: fit-content; max-width: 500px"
                @click="openImageModal(data.item.media.url)"
                v-b-modal.image_modal
              ></b-img>
            </div>
          </template>

          <template #cell(camera_proxy)="data">
            <b-link
              class="theme-link"
              @click="showVideo(data.item)"
            >
              {{ data.item.camera_proxy.camera.name }}
            </b-link>
          </template>

          <template #cell(data)="data">
            <pre style="max-height: 150px" v-if="data.item.data">{{
              JSON.stringify(data.item.data, null, "\t")
            }}</pre>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted text-capitalize">{{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <Pagination
                :totalList="totalList"
                :currentPage="currentPage"
                @updatePagination="update"
                :perPage="perPage"
              >
              </Pagination>
            </b-col>
          </b-row>
        </div>
        </b-card>
      </Transition>

      <!-- Modal -->
      <Transition name="slide-right-left" v-if="selectedRow">
        <b-card
          :class="!showFilters ? 'showScroll ml-0' : 'sticky-card ml-2'"
          no-body
        >
        <div class="ml-auto float-rigth">
          <feather-icon
            icon="XIcon"
            class="mr-2 ml-auto mt-2 float-rigth"
            style="cursor: pointer"
            size="30"
            @click="closeCard"
          />
        </div>
        <div class="mx-2" v-if="detectionEvent">
          <lpr-detection
            v-if="detectionEvent.event_type == 'lpr'"
            :detectionEvent="detectionEvent"
          />

          <fr-detection
            v-if="detectionEvent.event_type == 'fr'"
            :detectionEvent="detectionEvent"
          />

          <generic-detection
            v-if="detectionEvent.event_type != 'lpr' && detectionEvent.event_type != 'fr'"
            :detectionEvent="detectionEvent"
          />
        </div>
        </b-card>
      </Transition>
    </b-card-group>

    <!-- <div class="float-video-container" v-if="selectedObject" style="z-index: 100">
      <feather-icon
        icon="XIcon"
        class="float-video-container_close-btn"
        style="cursor: pointer"
        size="20"
        @click="closeDataModal"
      />
      <div class="mx-2">
        <div class="detection-evt-video-container">
          <p>
            ID: {{ selectedObject.event_data.id }} |
            {{ selectedObject.event_data.formatted_event_type }} -
            {{ selectedObject.event_data.event_created_at }}
          </p>
          <cam-slot
            v-if="selectedObject.camera_data"
            :data="selectedObject.camera_data"
            :type="selectedObject.type"
          />
        </div>
      </div>
    </div> -->

    <metadata-search-modal @search="refetchData()" @clear="clearSearchFilters()">
      <!-- Filters -->
      <template v-slot:main-filters>
        <filters
          :unit-filter.sync="unitFilter"
          :unit-options="unitOptions"
          :tenant-filter.sync="tenantFilter"
          :tenant-options="tenantOptions"
          :camera-filter.sync="cameraFilter"
          :camera-options="cameraOptions"
          :event-type-filter.sync="eventTypeFilter"
          :event-type-options="eventTypeOptions"
          :provider-filter.sync="providerFilter"
          :provider-options="providerOptions"
          :start-datetime.sync="startDatetimeFilter"
          :end-datetime.sync="endDatetimeFilter"
          :alarm-filter.sync="alarmFilter"
        />
      </template>
      <template v-slot:meta-filters>
        <meta-filters-component v-model="objectTypeData" />
      </template>
    </metadata-search-modal>

    <Transition name="slide-right-left">
      <div v-if="!showFilters && isFilterPanelOpen" class="filters-panel-fullscreen">
        <div class="filters-panel-header">
          <p class="h4 text-capitalize mb-2 text-white">
            {{ $t("messages.info.advanced_search") }}
          </p>
          <b-button
            variant="link"
            size="sm"
            @click="isFilterPanelOpen = false"
            class="text-dark p-0"
          >
            <feather-icon icon="XIcon" size="24" />
          </b-button>
        </div>
        <div class="filters-panel-content">
          <filters
            :unit-filter.sync="unitFilter"
            :unit-options="unitOptions"
            :tenant-filter.sync="tenantFilter"
            :tenant-options="tenantOptions"
            :camera-filter.sync="cameraFilter"
            :camera-options="cameraOptions"
            :event-type-filter.sync="eventTypeFilter"
            :event-type-options="eventTypeOptions"
            :provider-filter.sync="providerFilter"
            :provider-options="providerOptions"
            :start-datetime.sync="startDatetimeFilter"
            :end-datetime.sync="endDatetimeFilter"
            :alarm-filter.sync="alarmFilter"
          />
          <meta-filters-component v-model="objectTypeData" />
        </div>
        <div class="filters-panel-footer">
          <b-button
            variant="outline-primary"
            size="sm"
            @click="clearSearchFilters()"
            class="text-capitalize"
          >
            {{ $t("messages.info.clear_filters") }}
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            @click="applyFilters()"
            class="text-capitalize"
          >
            {{ $t("search") }}
            <feather-icon icon="SearchIcon" />
          </b-button>
        </div>
      </div>
    </Transition>

    <!-- Embedded in a MainSlot grid slot, GridView already provides the shared
         "image_modal" instance; mounting a second one opens a duplicate modal. -->
    <image-modal v-if="showFilters" />

    <b-modal
      v-model="showFireSmokeModal"
      :title="$t('detection_event.fire_smoke.modal_title')"
      centered
      :ok-title="$t('detection_event.fire_smoke.export')"
      :cancel-title="$t('detection_event.fire_smoke.cancel')"
      :ok-disabled="fireSmokeExporting"
      @ok.prevent="exportFireSmoke"
    >
      <b-form-group :label="$t('detection_event.fire_smoke.date_range')">
        <flat-pickr
          class="form-control"
          :config="fireSmokeConfig"
          v-model="fireSmokeRangeStr"
          @on-change="(selectedDates) => (fireSmokeDates = selectedDates)"
        />
      </b-form-group>
    </b-modal>

    <Teleport to="body">
      <floating-cam-v2
        v-if="selectedObject"
        class="float-video"
        :key="uuid"
        :camera-id="selectedObject.camera_data.camera.camera_id"
        :uuid="uuid"
        :camera-proxy-id="selectedObject.camera_data.camera.camera_proxy_id"
        :date-range="dateRange"
        @destroy="handleDestroy"
      />
    </Teleport>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
  BModal,
  BFormGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import axios from "@axios";
import useList from "./useList";
import Filters from "./Filters.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import ToastificationProgressContent from "@core/components/toastification/ToastificationProgressContent.vue";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import Pagination from "@/components/Pagination.vue";
import ImageModal from "../components/GridView/widgets/ImageModal.vue";
import MetadataSearchModal from "@/components/MetadataSearchModal.vue";
import MetaFiltersComponent from "@/components/MetaFiltersComponent";
import store from "@/store";
import CamSlot from "../components/GridView/layouts/slots/CamSlot.vue";
import { SLOT_TYPES } from "@/config/layoutConfig";
import { ref, computed, watch, nextTick } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ToastificationLoadingContent from "@/@core/components/toastification/ToastificationLoadingContent.vue";
import FrDetection from "@/views/components/DetectionEventSlot/FrDetection.vue";
import LprDetection from "@/views/components/DetectionEventSlot/LprDetection.vue";
import GenericDetection from "@/views/components/DetectionEventSlot/GenericDetection.vue";
import ToggleClearFilter from "@/components/Filters/ToggleClearFilter.vue";
import Teleport from "vue2-teleport";
import moment from "moment-timezone";

import FloatingCamV2 from "@/components/FloatingCamV2.vue";
import { v4 as uuidv4 } from 'uuid';
import BtnRefreshTable from "@/components/Btn Refresh Table/index.vue";

export default {
  components: {
    Filters,
    BreadcrumbMenu,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BModal,
    BFormGroup,
    flatPickr,
    vSelect,
    ToastificationProgressContent,
    Pagination,
    ImageModal,
    CamSlot,
    MetadataSearchModal,
    MetaFiltersComponent,
    ToastificationLoadingContent,
    LprDetection,
    FrDetection,
    GenericDetection,
    ToggleClearFilter,
    FloatingCamV2,
    Teleport,
    BtnRefreshTable,
  },
  props: {
    filters: {
      type: Object | Array,
    },
    showFilters: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    //start pagination
    const update = (data) => {
      currentPage.value = data;
    };
    const uuid = uuidv4();
    //end pagination
    const selectedRow = ref(null);
    const detectionEvent = ref(null);
    const selectedObject = ref(null);
    const isFilterPanelOpen = ref(false);
    const { t } = useI18nUtils();
    const buttonExport = ref(false);
    const progressToast = ref(null);
    const hiddenTable = ref(false);
    const progress = computed(() => store.getters["detection_event/getProgress"]);
    const error = computed(() => store.getters["detection_event/getError"]);
    const url = computed(() => store.getters["detection_event/getUrl"]);

    const toast = useToast();

    const trans = {
      "messages.export.download": t("messages.export.download"),
      "messages.export.Generating_file": t("messages.export.Generating_file"),
      "messages.error.server_error": t("messages.error.server_error"),
      "messages.delete.title": t("messages.delete.title"),
      "messages.delete.body": t("messages.delete.body"),
      "actions.delete": t("actions.delete"),
      "actions.cancel": t("actions.cancel"),
    };

    const openImageModal = async (imageUrl) => {
      await store.dispatch("image_modal/imageUrl", imageUrl);
    };

    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      clearSearchFilters,
      alarmFilter,
      ntechLabAll,
      unitFilter,
      unitOptions,
      cameraFilter,
      cameraOptions,
      tenantOptions,
      tenantFilter,
      eventTypeFilter,
      eventTypeOptions,
      providerFilter,
      providerOptions,
      startDatetimeFilter,
      endDatetimeFilter,
      objectTypeData,
      applyChartFilters,
      filtersCount,
      buildFilters,
    } = useList();

    const onRowSelected = (item) => {
      if (!item.length) {
        return;
      }

      if (!props.showFilters) {
        hiddenTable.value = true;
      }

      selectedRow.value = item[0];
      detectionEvent.value = item[0];
    };

    const closeDataModal = () => {
      selectedObject.value = null;
    };

    const closeCard = () => {
      hiddenTable.value = false;
      selectedRow.value = null;
      detectionEvent.value = null;
    };

    const showVideo = (item) => {
      if (!props.showFilters) {
        return;
      }
      selectedObject.value = null;
      const selectedItem = item;
      if (selectedItem && selectedItem.camera) {
        nextTick(() => {
          selectedObject.value = {
            event_data: selectedItem,
            camera_data: {
              camera: selectedItem.camera,
              ts: selectedItem.created_at,
            },
            type: SLOT_TYPES.CAM_PA,
          };
        });
      }
    };

    const handleDestroy = () => {
      selectedObject.value = null;
    };

    const dateRange = computed(() => {
      // Verifica si selectedObject y camera_data existen
      if (
        selectedObject.value &&
        selectedObject.value.camera_data &&
        selectedObject.value.camera_data.camera &&
        selectedObject.value.camera_data.ts
      ) {
        const camera = selectedObject.value.camera_data.camera;
        const fixedDate = selectedObject.value.camera_data.ts; // Fecha en formato "2024-08-12 09:14:50"

        console.log(selectedObject.value)

        // Verifica si la fecha es válida
        if (!moment(fixedDate, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
          return { startDate: null, endDate: null };
        }

        // Usa moment para manejar la fecha
        const ts = moment(fixedDate, "YYYY-MM-DD HH:mm:ss");

        // Obtén los tiempos de retraso y avance
        const delayedMin = camera.delayed_record_minutes || "00:02:00"; // Por defecto retraso de 2 minutos
        const forwardMin = camera.forward_record_minutes || "00:00:30"; // Por defecto avance de 30 segundos

        // Calcula el rango de tiempo
        let startDate = ts.clone().subtract(moment.duration(delayedMin));
        let endDate = ts.clone().add(moment.duration(forwardMin));

        // Si la fecha de fin es en el futuro, ajústala a la actual
        if (endDate.isAfter(moment())) {
          endDate = ts;
        }

        // Formatea las fechas a "YYYY-MM-DD HH:mm:ss"
        startDate = startDate.format("YYYY-MM-DD HH:mm:ss");
        endDate = endDate.format("YYYY-MM-DD HH:mm:ss");

        return { startDate, endDate };
      }

      // Si selectedObject o sus propiedades no existen, devolver null
      return { startDate: null, endDate: null };
    });

    applyChartFilters(props.filters);

    const applyFilters = () => {
      refetchData();
      isFilterPanelOpen.value = false;
    };

    // Export =============================

    store.dispatch("grid/findDownloadNotification", "detection-event").then((data) => {
      if (data.length > 0) {
        buttonExport.value = true;
        progressToast.value.show("Descarga", "Generando archivo...", "secondary");
      }
    });

    const exportExcel = () => {
      buttonExport.value = true;
      store.dispatch("detection_event/resetProgress");
      progressToast.value.show("Descarga", "Generando archivo...", "secondary");

      store
        .dispatch("detection_event/getAll", {
          ...buildFilters(),
          action: "export",
        })
        .then((response) => {
          store.dispatch("detection_event/setExport", response.data.jobId);
        })
        .catch((error) => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error exportando la información",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          buttonExport.value = false;
          progressToast.value.close();
        });
    };

    // Export fuego y humo =============================

    const showFireSmokeModal = ref(false);
    const fireSmokeExporting = ref(false);

    const defaultFrom = moment().startOf("day"); // 00:00
    const defaultTo = moment().endOf("day"); // 23:59
    const fireSmokeDates = ref([defaultFrom.toDate(), defaultTo.toDate()]);
    const fireSmokeRangeStr = ref(
      `${defaultFrom.format("YYYY-MM-DD HH:mm")} to ${defaultTo.format("YYYY-MM-DD HH:mm")}`
    );

    const fireSmokeConfig = {
      mode: "range",
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      time_24hr: true,
      minuteIncrement: 1,
    };

    const exportFireSmoke = async () => {
      if (!fireSmokeDates.value || fireSmokeDates.value.length < 2) {
        toast({
          component: ToastificationContent,
          props: {
            title: t("detection_event.fire_smoke.select_range"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      fireSmokeExporting.value = true;
      const from = moment(fireSmokeDates.value[0]).format("YYYY-MM-DDTHH:mm:00");
      const to = moment(fireSmokeDates.value[1]).format("YYYY-MM-DDTHH:mm:59");

      try {
        const response = await axios.get(
          "v1/detection_event/fire-smoke/export-test",
          {
            params: { from, to },
            responseType: "blob",
          }
        );

        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `reporte-fuego-humo-${from}_${to}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        showFireSmokeModal.value = false;
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: t("detection_event.fire_smoke.export_error"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        fireSmokeExporting.value = false;
      }
    };

    function getQueryParam(param) {
      const queryString = window.location.hash.split('?')[1]; // Extract the query string after `#`
      if (!queryString) return null;

      const params = new URLSearchParams(queryString);
      return params.get(param);
    }

    const ntechLabAllUrl = getQueryParam('ntechLabAll');
    if (ntechLabAllUrl) {
      ntechLabAll.value = ntechLabAllUrl;
    }

    const appendParamIfNotS3 = (url, param) => {
      const isS3 = /s3([-.][a-z0-9]+)*\.amazonaws\.com/.test(url);

      if (isS3) {
        return url;
      }

      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}${param}`;
    };

    watch([progress], () => {
      progressToast.value.updateProgress(progress.value);
    });

    watch([error], () => {
      toast({
        component: ToastificationContent,
        props: {
          title: error,
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
      buttonExport.value = false;
      progressToast.value.close();
    });

    watch([url], () => {
      if (url.value) {
        const link = document.createElement("a");
        link.href = url.value;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        buttonExport.value = false;
        progressToast.value.close();
      }
    });

    const loadingToast = ref(null);
    const action = ref("list");

    return {
      buttonExport,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      clearSearchFilters,
      alarmFilter,
      loadingToast,
      action,
      update,

      unitOptions,
      unitFilter,
      cameraFilter,
      cameraOptions,
      tenantOptions,
      tenantFilter,
      eventTypeFilter,
      eventTypeOptions,
      providerFilter,
      providerOptions,

      startDatetimeFilter,
      endDatetimeFilter,
      objectTypeData,

      openImageModal,
      closeDataModal,

      filtersCount,
      onRowSelected,
      exportExcel,
      showFireSmokeModal,
      fireSmokeExporting,
      fireSmokeDates,
      fireSmokeRangeStr,
      fireSmokeConfig,
      exportFireSmoke,
      progressToast,
      selectedRow,
      detectionEvent,
      hiddenTable,
      closeCard,

      showVideo,
      selectedObject,
      uuid,
      handleDestroy,
      dateRange,
      tokenImg: localStorage.getItem('additionalTokenImage'),
      appendParamIfNotS3,
      isFilterPanelOpen,
      applyFilters,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/utilities/transitions";

.per-page-selector {
  width: 90px;
}

.sticky-card {
  position: sticky;
  top: 6rem;
  height: 80vh;
  overflow: auto;
}

.float-video {
  position: absolute;
  top: 7rem;
  left: 5rem;
  z-index: 1050;
}

.spinner {
  margin-top: calc(50% - 100px);
  margin-left: 50%;
}

.showScroll {
  position: sticky;
  top: 6rem;
  height: auto;
  overflow: hidden;
}

.theme-link {
  padding: 50% 0px 50% 0;

  body.dark-layout & {
    color: #F0F8FF;

    &:hover {
      color: #aeaeae;
    }
  }

  body:not(.dark-layout) & {
    color: #7d7a89;

    &:hover {
      color: #504e56;
    }
  }
}

.filters-panel-fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 10;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 0;
}

.filters-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 0;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.filters-panel-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 1.5rem;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.filters-panel-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e9ecef;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  flex-shrink: 0;
}

.modal-title {
  color: #eeeeee;
}

.dark-layout {
  .filters-panel-fullscreen {
    background-color: #283046;
    color: #b4b7bd;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }

  .filters-panel-header {
    border-bottom-color: rgba(255, 255, 255, 0.05);
  }

  .filters-panel-footer {
    border-top-color: #3b4253;
  }

  .filters-panel-content {
    &::-webkit-scrollbar-track {
      background: #161d31;
    }

    &::-webkit-scrollbar-thumb {
      background: #3b4253;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #4b5563;
    }
  }
}
</style>
